<template>
    <div class="container">
        <el-card shadow="never" class="practice-analysis">
            <el-row :gutter="20" class="practice-analysis-header">
                <el-col :span="14">
                    <el-row>
                        <el-col :span="8">
                            <el-radio-group v-model="tabs" size="small" class="tabs">
                                <el-radio-button label="have">有重复题目</el-radio-button>
                                <el-radio-button label="none">没有重复题目</el-radio-button>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="16">
                            <el-button size="small">返回</el-button>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="10">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-select v-model="value" placeholder="请选择" size="small">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <el-select v-model="value" placeholder="请选择" size="small">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <el-button type="primary" size="small">查询</el-button>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="practice-analysis-center">
                <el-col :span="24">
                    <span>做答量 :</span>
                    <i class="zdl"></i>
                    <span>{{zdl}}</span>
                </el-col>
                <el-col :span="24">
                    <span>答对量 :</span>
                    <i class="ddl"></i>
                    <span>{{ddl}}</span>
                </el-col>
                <el-col :span="24">
                    <span>正确率 :</span>
                    <i class="zql"></i>
                    <span v-html="(ddl/zdl)*100+'%'"></span>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tabs: "have",
            options: [
                {
                    value: "1",
                    label: "2019年"
                },
                {
                    value: "2",
                    label: "2018年"
                }
            ],
            value: "1",
            zdl: "40",
            ddl: "15"
        };
    },
    methods: {
        init() {
            let a = document.querySelector(".zdl");
            let b = document.querySelector(".ddl");
            let c = document.querySelector(".zql");
            a.style.width = "200px";
            b.style.width = (this.ddl / this.zdl) * 200 + "px";
            c.style.width = (this.ddl / this.zdl) * 200 + "px";
        }
    },
    mounted() {
        this.init();
    }
};
</script>
<style lang="less" scoped>
.practice-analysis {
    margin-top: 30px;
    min-height: 500px;
    .practice-analysis-header {
        padding-bottom: 20px;
        border-bottom: 1px solid #e7eaec;
    }
    .practice-analysis-center {
        margin-top: 20px;
        padding-left: 40px;
        > div {
            margin-bottom: 10px;
            > span {
                float: left;
                margin-right: 5px;
            }
            i {
                height: 20px;
                width: 200px;
                float: left;
                margin-right: 5px;
            }
            .zdl{
                background-color: #da70d6;
            }
            .ddl{
                background-color: #14b14e;
            }
            .zql{
                background-color: #ff7f50;
            }
        }
    }
}
</style>